<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">保養執行表</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <commonQueryInput
            :inputItems="multiInputItems"
            v-model:getValue="multiInputVal"
          ></commonQueryInput>
          <div class="gap-2 d-md-flex justify-content-md-end">
            <template v-if="!mod">
              <a
                class="btn p-0"
                style="
                  color: #fff;
                  background-color: #4b8c80;
                  width: 6rem;
                  height: 2rem;
                  font-size: 1.125rem;
                  line-height: 2rem;
                "
                :class="{
                  disabled:
                    !queryCheck || maintainScheduleTableItems.length == 0,
                }"
                :href="queryCheck ? excelSrc : '#'"
                >匯出Excel</a
              >
            </template>
          </div>

          <commonTable
            :fields="maintainScheduleTableFields"
            :items="maintainScheduleTableItems"
            :theme="'green'"
            stickyHeader="450px"
            style="margin-top: 0.6rem"
          >
            <template #cell(ckeckResult)="data">
              <template v-if="mod">
                <div style="width: 180px">
                  <button
                    class="btn p-0 pe-1 mes-maintain-check-button"
                    :class="{
                      'mes-maintain-check-button-pass': data.value == 1,
                    }"
                    @click="selectResult('ckeckResult', data.index, 1)"
                  >
                    <font-awesome-icon
                      style="width: 25px; color: green"
                      :icon="['fas', 'check']"
                    />OK
                  </button>
                  /
                  <button
                    class="btn p-0 pe-1 mes-maintain-check-button"
                    :class="{
                      'mes-maintain-check-button-ng': data.value == -1,
                    }"
                    @click="selectResult('ckeckResult', data.index, -1)"
                  >
                    <font-awesome-icon
                      style="width: 25px; color: red"
                      :icon="['fas', 'xmark']"
                    />NG
                  </button>
                </div>
              </template>
              <template v-else>
                <template v-if="data.value == 1">
                  <font-awesome-icon
                    style="width: 25px; color: green"
                    :icon="['fas', 'check']"
                  />OK
                </template>
                <template v-else-if="data.value == -1">
                  <font-awesome-icon
                    style="width: 25px; color: red"
                    :icon="['fas', 'xmark']"
                  />NG
                </template>
                <template v-else> - </template>
              </template>
            </template>
            <template #cell(ckeck_op)="data">
              {{ data.value == "" ? "-" : data.value }}
            </template>
            <template #cell(completeTime)="data">
              <template v-if="mod">
                <template
                  v-if="
                    maintainScheduleTableItems[data.index].completeTime != '' &&
                    maintainScheduleTableItems[data.index].completeTime != null
                  "
                >
                  <commonDateInput
                    class="mes-maintain-input-date"
                    v-model:getValue="
                      maintainScheduleTableItems[data.index].completeTimeInput
                    "
                    :defaultDate="
                      maintainScheduleTableItems[data.index].completeTime
                    "
                    type="date"
                    @click="
                      selectResult(
                        'completeTime',
                        data.index,
                        maintainScheduleTableItems[data.index].completeTimeInput
                      )
                    "
                  >
                  </commonDateInput>
                </template>
                <template v-else> - </template>
              </template>
              <template v-else>
                {{ data.value == "" ? "-" : data.value }}
              </template>
            </template>
          </commonTable>
          <div class="gap-2 d-md-flex justify-content-md-end mt-3">
            <template v-if="mod">
              <button
                type="button"
                class="btn p-0"
                style="
                  color: #fff;
                  background-color: #4b8c80;
                  width: 6rem;
                  height: 2rem;
                  font-size: 1.125rem;
                "
                @click="cancelUpdate"
              >
                取消修改
              </button>
              <button
                type="button"
                class="btn p-0"
                style="
                  color: #fff;
                  background-color: #4b8c80;
                  width: 6rem;
                  height: 2rem;
                  font-size: 1.125rem;
                "
                @click="checkUpdate"
              >
                確認修改
              </button>
            </template>
            <template v-else>
              <button
                type="button"
                class="btn p-0"
                style="
                  color: #fff;
                  background-color: #4b8c80;
                  width: 6rem;
                  height: 2rem;
                  font-size: 1.125rem;
                "
                @click="mod = true"
                :class="{ disabled: maintainScheduleTableItems.length === 0 }"
              >
                進行修改
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonDateInput from "@/components/commonQueryInput/commonDateInput.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, provide, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    commonDateInput,
    commonTable,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const selectYear = ref();
    const selectMonth = ref();

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "month",
        label: "年度/月份",
        checkEmpty: true,
        type: "month", // date/dateBetween/text/select/time/month
      },
    ]);
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        mod.value = false;
        console.log(newValue);
        let split_values = newValue["month"].split("-");

        selectYear.value = split_values[0];
        selectMonth.value = split_values[1];

        queryDeviceMaintainExecute();
      },
      { deep: true }
    );

    const mod = ref(false);
    const queryCheck = ref(false);
    const excelSrc = ref("");

    const maintainScheduleTableFields = ref([
      {
        key: "dep",
        label: "部門",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device",
        label: "設備代號",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "deviceName",
        label: "設備名稱",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "systemName",
        label: "系統名稱",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "systemItem",
        label: "系統項次",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "checkItem",
        label: "檢查項目",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeckList",
        label: "檢查內容",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeckResult",
        label: "檢查結果",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeck_op",
        label: "檢查人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeTime",
        label: "完成時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const maintainScheduleTableItems = ref([
      // {
      //   scheduleID: "1785",
      //   dep: "G5221",
      //   device: "LMS-13-003-1",
      //   deviceName: "批式保溫爐",
      //   systemName: "2.機構系統",
      //   systemItem: "02001",
      //   checkItem: "爐門鍊條",
      //   ckeckList: "鬆緊度檢查",
      //   ckeckResult: "",
      //   ckeck_op: "",
      //   ckeck_op_id: "",
      //   completeTimeInput: "",
      //   completeTime: "",
      // },
      // {
      //   scheduleID: "1786",
      //   dep: "G5221",
      //   device: "LMS-02-011",
      //   deviceName: "GFM RF-70精密鍛造機",
      //   systemName: "1.鍛造手",
      //   systemItem: "01001",
      //   checkItem: "旋轉馬達和角度馬達",
      //   ckeckList: "檢查皮帶鬆緊度",
      //   ckeckResult: "",
      //   ckeck_op: "",
      //   ckeck_op_id: "",
      //   completeTimeInput: "",
      //   completeTime: "",
      // },
      // {
      //   scheduleID: "1787",
      //   dep: "G5221",
      //   device: "LMS-02-011",
      //   deviceName: "GFM RF-70精密鍛造機",
      //   systemName: "1.鍛造手",
      //   systemItem: "01002",
      //   checkItem: "齒油箱",
      //   ckeckList: "檢查齒輪油#680的狀況(瓶上方油位)",
      //   ckeckResult: "",
      //   ckeck_op: "",
      //   ckeck_op_id: "",
      //   completeTimeInput: "",
      //   completeTime: "",
      // },
    ]);

    const queryDeviceMaintainExecute = () => {
      mod.value = false;
      queryCheck.value = false;
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryDeviceMaintainExecute";
      params["year"] = selectYear.value;
      params["month"] = selectMonth.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          maintainScheduleTableItems.value =
            QueryTableData["maintainScheduleTableItems"];
          queryCheck.value = true;
          excelSrc.value = `https://${QueryTableData["ip"]}:3687/api/export_excel?year=${selectYear.value}&month=${selectMonth.value}`;
        } else {
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };

    //更新選擇的值
    const selectResult = (type, index, value) => {
      const currentItem = maintainScheduleTableItems.value[index];
      console.log(type, index, value);
      switch (type) {
        case "ckeckResult":
          if (currentItem["ckeckResult"] === value) return;

          if (currentItem["orgCkeckResult"] === undefined) {
            currentItem["orgCkeckResult"] = currentItem["ckeckResult"];
            currentItem["orgCompleteTime"] = currentItem["completeTime"];
          }
          if (currentItem["orgCkeck_op_id"] === undefined) {
            currentItem["orgCkeck_op"] = currentItem["ckeck_op"];
            currentItem["orgCkeck_op_id"] = currentItem["ckeck_op_id"];
          }

          currentItem["ckeckResult"] = value;
          currentItem["ckeck_op"] = loginData.value.username;
          currentItem["ckeck_op_id"] = loginData.value.account;

          const now = new Date();
          const formattedDateTime = `${now.getFullYear()}-${(
            "0" +
            (now.getMonth() + 1)
          ).slice(-2)}-${("0" + now.getDate()).slice(-2)}`;

          currentItem["completeTime"] = formattedDateTime;
          currentItem["completeTimeInput"] = { startDate: formattedDateTime };
          break;

        case "completeTime":
          if (currentItem["completeTime"] === value.startDate) return;

          if (currentItem["orgCompleteTime"] === undefined) {
            currentItem["orgCompleteTime"] = currentItem["completeTime"];
          }
          if (currentItem["orgCkeck_op_id"] === undefined) {
            currentItem["orgCkeck_op"] = currentItem["ckeck_op"];
            currentItem["orgCkeck_op_id"] = currentItem["ckeck_op_id"];
          }

          currentItem["completeTime"] = value.startDate;
          currentItem["ckeck_op"] = loginData.value.username;
          currentItem["ckeck_op_id"] = loginData.value.account;
          break;

        default:
          break;
      }
    };

    //將值復原到修改前的值
    const cancelUpdate = () => {
      queryDeviceMaintainExecute();
    };

    //取得被修改的項目並儲存到updateData
    const checkUpdate = () => {
      let updateData = maintainScheduleTableItems.value
        .filter((data) => {
          return (
            data.orgCkeck_op_id !== undefined &&
            ((data.orgCkeckResult !== undefined &&
              data.orgCkeckResult !== data.ckeckResult) ||
              (data.orgCompleteTime !== undefined &&
                data.orgCompleteTime !== data.completeTime))
          );
        })
        .map((data) => ({
          scheduleID: data.scheduleID,
          result: data.ckeckResult,
          op: data.ckeck_op_id,
          completeTime: data.completeTime,
        }));

      // maintainScheduleTableItems.value = maintainScheduleTableItems.value.map(
      //   ({
      //     orgCkeckResult,
      //     orgCkeck_op,
      //     orgCkeck_op_id,
      //     orgCompleteTime,
      //     ...rest
      //   }) => rest
      // );

      if (updateData.length == 0) {
        methods.setTimeoutAlert("無修改項目");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateMaintainExecution";
      params["year"] = selectYear.value;
      params["month"] = selectMonth.value;
      params["updateData"] = updateData;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        methods.triggerLoadingBar();
        queryDeviceMaintainExecute();
      });
    };

    return {
      multiInputVal,
      multiInputItems,
      mod,
      queryCheck,
      excelSrc,
      maintainScheduleTableFields,
      maintainScheduleTableItems,
      selectResult,
      cancelUpdate,
      checkUpdate,
    };
  },
};
</script>

<style>
.mes-maintain-check-button {
  background-color: transparent;
  color: #000;
  border: 1px var(--main-bg-color) solid;
  width: 75px;
  height: 2rem;
}
.mes-maintain-check-button-pass:hover,
.mes-maintain-check-button-ng:hover {
  color: #fff;
}
.mes-maintain-check-button-pass {
  background-color: #008000;
  color: #fff;
  border: 1px #008000 solid;
}
.mes-maintain-check-button-ng {
  background-color: #ff0000;
  color: #fff;
  border: 1px #ff0000 solid;
}
.mes-maintain-check-button-pass > svg,
.mes-maintain-check-button-ng > svg {
  color: #fff !important;
}
.mes-maintain-input-date input {
  text-align: center;
}
</style>
